/* =========================================================================
   JEW'KIDS — Colombe vers le panier  (dove-to-cart)
   Vanilla JS, zéro dépendance. S'injecte ses propres styles.
   -------------------------------------------------------------------------
   Au clic sur un bouton « Ajouter au panier », une colombe s'envole de
   l'article jusqu'à l'icône panier (bat des ailes, traînée dorée, rebond +1).
   Responsive : la colombe rétrécit sur mobile. Respecte prefers-reduced-motion.

   CONFIG (optionnelle) via attributs data- sur la balise <script> :
     data-cart="#cart-icon-bubble"   sélecteur de l'icône panier
     data-triggers="..."             sélecteur des boutons d'ajout
     data-duration="2250"            durée du vol (ms)
   ou via  window.DOVE_CONFIG = { cart, triggers, duration }  avant le script.

   API : window.JewKidsDove.fly(fromElement)   pour déclencher manuellement.
   ========================================================================= */
(function () {
  "use strict";

  var script = document.currentScript || (function () {
    var s = document.getElementsByTagName('script'); return s[s.length - 1];
  })();
  var ds = (script && script.dataset) || {};
  var CFG = window.DOVE_CONFIG || {};

  var CART_SEL = CFG.cart || ds.cart ||
    '#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href*="/cart"], [data-dove-cart]';
  var TRIGGER_SEL = CFG.triggers || ds.triggers ||
    '[data-dove], form[action*="/cart/add"] [type="submit"], button[name="add"], ' +
    '.product-form__submit, .quick-add__submit, .add-to-cart, .btn-cart';
  var DURATION = parseInt(CFG.duration || ds.duration || 2250, 10);

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- styles (injected once) ---------- */
  var CSS =
  '.jkd-dove{position:fixed;top:0;left:0;z-index:2147483600;pointer-events:none;will-change:transform;filter:drop-shadow(0 6px 10px rgba(150,90,20,.35));}' +
  '.jkd-dove svg{width:100%;height:100%;display:block;overflow:visible;}' +
  '.jkd-w1,.jkd-w2{transform-box:fill-box;}' +
  '.jkd-w1{transform-origin:8% 86%;animation:jkdFlap .32s ease-in-out infinite alternate;}' +
  '.jkd-w2{transform-origin:10% 84%;animation:jkdFlap2 .32s ease-in-out infinite alternate;}' +
  '@keyframes jkdFlap{from{transform:rotate(-56deg);}to{transform:rotate(20deg);}}' +
  '@keyframes jkdFlap2{from{transform:rotate(-40deg);}to{transform:rotate(30deg);}}' +
  '.jkd-trail{position:fixed;top:0;left:0;width:8px;height:8px;border-radius:50%;z-index:2147483599;pointer-events:none;background:radial-gradient(circle,#ffe1a0,rgba(255,217,138,0) 70%);transform:translate(-50%,-50%);animation:jkdTrail .6s ease forwards;}' +
  '@keyframes jkdTrail{to{opacity:0;transform:translate(-50%,-50%) scale(.3);}}' +
  '.jkd-bump{animation:jkdBump .55s cubic-bezier(.34,1.56,.5,1);}' +
  '@keyframes jkdBump{0%{transform:none;}30%{transform:scale(1.3) rotate(-7deg);}55%{transform:scale(.9);}100%{transform:none;}}' +
  '.jkd-ring{position:absolute;border-radius:50%;border:2px solid currentColor;color:#ff6b00;pointer-events:none;animation:jkdRing .6s ease-out forwards;}' +
  '@keyframes jkdRing{from{opacity:.7;transform:scale(.55);}to{opacity:0;transform:scale(1.9);}}' +
  '.jkd-plus{position:fixed;z-index:2147483601;font-family:Fredoka,system-ui,sans-serif;font-weight:600;font-size:16px;color:#ff6b00;pointer-events:none;transform:translate(-50%,0);text-shadow:0 1px 0 #fff;animation:jkdPlus 1s ease forwards;}' +
  '@keyframes jkdPlus{0%{opacity:0;transform:translate(-50%,8px);}25%{opacity:1;}100%{opacity:0;transform:translate(-50%,-22px);}}' +
  '@media (prefers-reduced-motion:reduce){.jkd-dove,.jkd-trail{display:none!important;}}';

  function injectCSS() {
    if (document.getElementById('jkd-style')) return;
    var st = document.createElement('style');
    st.id = 'jkd-style';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ---------- dove artwork ---------- */
  var DOVE_SVG =
    '<svg viewBox="0 0 80 64" xmlns="http://www.w3.org/2000/svg">' +
    '<defs><linearGradient id="jkdg1" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#f7e6ad"/><stop offset=".5" stop-color="#e4c468"/><stop offset="1" stop-color="#c79a40"/></linearGradient>' +
    '<linearGradient id="jkdg2" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#efd79a"/><stop offset="1" stop-color="#d4ad55"/></linearGradient></defs>' +
    '<path class="jkd-w2" d="M45 31 C41 20 56 15 65 21 C57 25 51 29 51 37 C48 35 46 33 45 31 Z" fill="url(#jkdg2)"/>' +
    '<g>' +
    '<path d="M58 17 C52 15 47 18 45 23 C37 24 27 29 9 46 C17 42 26 40 31 40 C40 42 50 42 56 36 C61 32 62 24 59 20 Z" fill="#fff"/>' +
    '<path d="M9 46 L26 41 L21 35 Z" fill="#f4f0e6"/>' +
    '<circle cx="60" cy="22" r="7.6" fill="#fff"/>' +
    '<path d="M66 20.5 L77 23 L66 26 Z" fill="#f0a93a"/>' +
    '<circle cx="61" cy="21" r="1.7" fill="#3a2c12"/>' +
    '<path d="M73 25 q4 3 8 1 q-4 3 -8 -1 z" fill="#6fae46"/>' +
    '<circle cx="80.5" cy="25.5" r="1.7" fill="#5a9238"/>' +
    '</g>' +
    '<path class="jkd-w1" d="M45 28 C39 10 59 6 70 13 C60 18 51 24 51 36 C48 34 46 31 45 28 Z" fill="url(#jkdg1)"/>' +
    '</svg>';

  /* ---------- helpers ---------- */
  function findCart() {
    // prefer the VISIBLE cart icon (desktop header vs mobile dock can both exist)
    var list = CART_SEL.split(','), first = null;
    for (var i = 0; i < list.length; i++) {
      var els = document.querySelectorAll(list[i].trim());
      for (var j = 0; j < els.length; j++) {
        if (!first) first = els[j];
        var r = els[j].getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return els[j];
      }
    }
    return first;
  }

  function bumpCart(cart) {
    if (!cart) return;
    var cs = getComputedStyle(cart);
    if (cs.position === 'static') cart.style.position = 'relative';
    cart.classList.remove('jkd-bump'); void cart.offsetWidth; cart.classList.add('jkd-bump');

    var r = cart.getBoundingClientRect();
    var ring = document.createElement('span');
    ring.className = 'jkd-ring';
    var size = Math.max(r.width, r.height) + 10;
    ring.style.width = size + 'px'; ring.style.height = size + 'px';
    ring.style.left = (r.width / 2 - size / 2) + 'px';
    ring.style.top = (r.height / 2 - size / 2) + 'px';
    cart.appendChild(ring);
    setTimeout(function () { if (ring.parentNode) ring.remove(); }, 650);

    var plus = document.createElement('div');
    plus.className = 'jkd-plus'; plus.textContent = '+1';
    plus.style.left = (r.left + r.width / 2) + 'px';
    plus.style.top = (r.top - 14) + 'px';
    document.body.appendChild(plus);
    setTimeout(function () { if (plus.parentNode) plus.remove(); }, 1000);
  }

  function fly(fromEl) {
    injectCSS();
    var cart = findCart();
    if (!cart) return;                       // nothing to fly to
    if (reduce) { bumpCart(cart); return; }

    var a = (fromEl && fromEl.getBoundingClientRect)
      ? fromEl.getBoundingClientRect()
      : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    var b = cart.getBoundingClientRect();

    var sx = a.left + a.width / 2, sy = a.top + a.height / 2;
    var ex = b.left + b.width / 2, ey = b.top + b.height / 2;
    var cpx = (sx + ex) / 2, cpy = Math.min(sy, ey) - 170;

    // responsive size
    var small = innerWidth < 560;
    var W = small ? 54 : 78, H = small ? 43 : 62;

    var dove = document.createElement('div');
    dove.className = 'jkd-dove';
    dove.style.width = W + 'px'; dove.style.height = H + 'px';
    dove.innerHTML = DOVE_SVG;
    document.body.appendChild(dove);

    var t0 = performance.now(), n = 0, bumped = false, finished = false;
    var safety = setTimeout(function () {
      if (!bumped) { bumped = true; bumpCart(cart); }
      if (dove.parentNode) dove.remove(); finished = true;
    }, DURATION + 500);

    function end() {
      if (finished) return; finished = true;
      clearTimeout(safety);
      if (dove.parentNode) dove.remove();
    }

    function frame(now) {
      if (finished) return;
      var p = Math.min(1, (now - t0) / DURATION);
      var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      var x = (1 - e) * (1 - e) * sx + 2 * (1 - e) * e * cpx + e * e * ex;
      var y = (1 - e) * (1 - e) * sy + 2 * (1 - e) * e * cpy + e * e * ey;
      var sc = 1 - 0.4 * p;
      dove.style.transform = 'translate(' + x + 'px,' + y + 'px) translate(-50%,-50%) scale(' + sc + ')';
      dove.style.opacity = p > 0.92 ? (1 - (p - 0.92) / 0.08) : 1;
      if ((n++ % 3) === 0) {
        var tr = document.createElement('div');
        tr.className = 'jkd-trail';
        tr.style.left = x + 'px'; tr.style.top = (y + 6) + 'px';
        document.body.appendChild(tr);
        setTimeout(function () { if (tr.parentNode) tr.remove(); }, 600);
      }
      if (p > 0.92 && !bumped) { bumped = true; bumpCart(cart); }
      if (p < 1) requestAnimationFrame(frame); else end();
    }
    requestAnimationFrame(frame);
  }

  /* ---------- auto-wire add-to-cart triggers ---------- */
  function originFor(btn) {
    // closest product media to fly from, else the button itself
    var card = btn.closest('.card, .product-card, .grid__item, .product, li, article, form');
    var media = card && card.querySelector('img, .card__media, .product__media, picture');
    return media || btn;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(TRIGGER_SEL);
    if (!btn) return;
    fly(originFor(btn));
  }, true);

  window.JewKidsDove = { fly: fly };
})();
